<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="tag.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
                placeholder="Name"
            />

            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>

        <div class="form-group col-12">
            <label for="name">Category</label>

            <v-select
                v-model="selectedCategory"
                label="name"
                placeholder="Search..."
                :options="categories"
                :disabled="editMode"
                :class="{
                    'is-invalid': hasError('categoryId')
                }"
                @search="onCategorySearch"
            >
                <template slot="no-options">
                    Start typing to search for a category
                </template>
            </v-select>

            <div class="invalid-feedback">
                {{ getError('categoryId') }}
            </div>
        </div>
        <hr />

        <div
            v-if="tag.id && campusesTagsCount.length"
            class="form-group col-12"
        >
            <h5>Number of selections per campus:</h5>
            <div v-for="(campus, index) in campusesTagsCount" :key="index">
                {{ campus.name }} : <strong>{{ campus.tagCount }}</strong>
            </div>

            <div class="mt-2">
                Total: <strong>{{ totalNumberOftagsInAllCampuses }}</strong>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        validation: {
            type: Object,
            required: true
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },

        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            tag: {},
            categories: [],
            selectedCategory: null,
            campusesTagsCount: [],
            totalNumberOftagsInAllCampuses: null
        };
    },

    watch: {
        tag() {
            this.$emit('input', this.tag);
        },
        selectedCategory(value) {
            this.tag.categoryId = value ? value.id : null;
        }
    },

    async created() {
        const { category } = this.value;

        if (this.value.id) {
            this.campusesTagsCount = await this.getCampusesTagsCount(
                this.value.id
            );

            this.totalNumberOftagsInAllCampuses = this.campusesTagsCount.reduce(
                (prev, curr) => prev + curr.tagCount,
                0
            );
        }

        this.tag = {
            ...this.value,
            categoryId: category ? category.id : null
        };

        this.selectedCategory = category ? { ...category } : null;
    },

    methods: {
        ...mapActions({
            getCategories: 'studentTagCategories/index',
            getCampusesTagsCount: 'campuses/getCampusesTagsCount'
        }),

        async onCategorySearch(search, loading) {
            if (search.length) {
                loading(true);

                const { rows: categories } = await this.getCategories({
                    search
                });

                this.categories = categories;

                loading(false);
            }
        },

        hasError(key) {
            return (
                this.validation.tag[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.tag,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
